import { render, staticRenderFns } from "./re-activate-link.vue?vue&type=template&id=3796c0df&"
import script from "./re-activate-link.vue?vue&type=script&lang=js&"
export * from "./re-activate-link.vue?vue&type=script&lang=js&"
import style0 from "./re-activate-link.vue?vue&type=style&index=0&id=3796c0df&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports